<div class="lightreach-header">
    <div>Hardware approved by LightReach</div>
</div>
<div class="inverter-table-container">

    <div class="card">
        <div class="header">
            <div class="form-controls">
                <label class="form-label">Type</label>
                <div class="inverter-dropdown-wrapper">
                    <mat-form-field appearance="fill" class="type-field custom-form-field no-line">
                        <mat-select [(value)]="selectedType" [compareWith]="compareObjects"
                            (selectionChange)="getLightReachData()">
                            <mat-select-trigger>
                                {{ selectedType?.name }}
                            </mat-select-trigger>

                            <mat-option *ngFor="let type of typeOptions" [value]="type">
                                <div class="option-content">
                                    {{ type.name }}
                                    <mat-icon *ngIf="selectedType?.value === type.value"
                                        class="check-icon">check</mat-icon>
                                </div>
                            </mat-option>
                        </mat-select>

                    </mat-form-field>
                </div>

                <mat-form-field appearance="fill" class="search-field custom-form-field no-line">
                    <!-- <mat-icon matPrefix>search</mat-icon> -->
                    <img matPrefix src="/assets/images/search.svg" alt="search" class="custom-search-icon" />
                    <input #filterInput  matInput (keyup)="applyFilter($event)" placeholder="by Manufacturer or Model" />
                </mat-form-field>
            </div>
        </div>

        <table mat-table [dataSource]="filteredDataSource" class="custom-table">
            <ng-container matColumnDef="name">
                <th mat-header-cell *matHeaderCellDef> Name </th>
                <td mat-cell *matCellDef="let row"> {{ row.name }} </td>
            </ng-container>

            <ng-container matColumnDef="manufacturer">
                <th mat-header-cell *matHeaderCellDef> Manufacturer </th>
                <td mat-cell *matCellDef="let row"> {{ row.manufacturer }} </td>
            </ng-container>

            <ng-container matColumnDef="model">
                <th mat-header-cell *matHeaderCellDef> Model </th>
                <td mat-cell *matCellDef="let row"> {{ row.modelNumber }} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
        </table>
    </div>
</div>